import type { Point } from '../stage';

export function BetChip({ amount, at }: { amount: number; at: Point }) {
  return <span className="chip" style={{ left: at.x, top: at.y }} data-testid="chip">{amount}</span>;
}
